<div class="ct-modalContainer flex flex-col gap-5">
  <div class="flex justify-between w-full flex-row">
    <h2>
      Send to opportunity
      @if (data.opportunity) {
        : {{ data.opportunity.opportunityName }}
      }
    </h2>
    <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
  </div>
  @if (!data.dialogMode) {
    <div class="flex flex-col gap-5">
      @if (clientsList$ | async; as clientsList) {
        <div class="basicInput">
          <label class="basicInput__label">Select client</label>
          <input
            class="basicInput__input"
            list="clients"
            name="clients"
            data-test-id="select-opportunity-dialog-assign-client"
            (change)="assignClientAndGetOpportunities($event, clientsList)"
          />
          <datalist id="clients" data-test-id="select-opportunity-dialog-select-client">
            @for (client of clientsList; track client) {
              <option
                [value]="client.clientName"
                [attr.data-test-id]="`select-opportunity-dialog-client-option${$index}`"
              ></option>
            }
          </datalist>
        </div>
      }
      @if (opportunityList$ | async; as opportunityList) {
        <div class="basicInput">
          <label class="basicInput__label">Select opportunity</label>
          <input
            #OpportunityInput
            class="basicInput__input"
            list="opportunities"
            name="opportunities"
            data-test-id="select-opportunity-dialog-assign-opportunity"
            (change)="assignOpportunity($event, opportunityList)"
          />
          <datalist id="opportunities" data-test-id="select-opportunity-dialog-select-opportunity">
            @for (opportunity of opportunityList; track opportunity) {
              <option
                [value]="opportunity.opportunityName"
                [attr.data-test-id]="`select-opportunity-dialog-opportunity-option${$index}`"
              ></option>
            }
          </datalist>
        </div>
      }
    </div>
  }
  <div class="basicInput">
    <label class="basicInput__label">Name search</label>
    <input
      #SearchInput
      class="basicInput__input"
      list="searches"
      name="searches"
      data-test-id="select-opportunity-dialog-assign-search"
      (change)="assignSearch($event)"
    />
    <datalist id="searches" data-test-id="select-opportunity-dialog-select-search">
      @for (search of searchList; track search) {
        <option [value]="search"></option>
      }
    </datalist>
  </div>
  <div class="basicInput">
    <label class="basicInput__label">Expert segment</label>
    <select class="basicInput__input" data-test-id="select-opportunity-dialog-segment" [(ngModel)]="segment">
      <option value="">--Select segment--</option>
      @for (segment of segments; track segment) {
        <option [value]="segment" [attr.data-test-id]="`select-opportunity-dialog-segment-option${$index}`">
          {{ segment | expertSegment }}
        </option>
      }
    </select>
  </div>
  <div class="basicInput">
    <label class="basicInput__label">Expert target</label>
    <select
      #ExpertTargetInput
      class="basicInput__input"
      data-test-id="select-opportunity-dialog-target"
      [disabled]="!opportunitySegments?.length"
      (change)="assignExpertTarget($event)"
    >
      <option value="">--Select geography / profile type--</option>
      @for (target of opportunitySegments; track target) {
        <option [value]="target.id" [attr.data-test-id]="`select-opportunity-dialog-target-option${$index}`">
          {{ target.geography }} - {{ target.segment }}
        </option>
      }
    </select>
  </div>
  @if (connectUsers$ | async; as connectUsers) {
    <div class="basicInput">
      <label class="basicInput__label">Owner</label>
      <select class="basicInput__input" [compareWith]="expertOwnerCompare" [(ngModel)]="expertOwner">
        @for (user of connectUsers; track user) {
          <option [ngValue]="user" [attr.data-test-id]="`select-opportunity-dialog-user-option${$index}`">
            {{ user.first_name }} {{ user.last_name }}
          </option>
        }
      </select>
    </div>
  }

  <div class="flex flex-row gap-5">
    <button
      class="button button--secondary"
      id="submitAndRemain"
      data-test-id="select-opportunity-dialog-send-and-remain"
      [style]="{ 'pointer-events': showSendAndRemainButtonLoader || showSendAndGoButtonLoader ? 'none' : 'initial' }"
      [disabled]="!client || !opportunity || !newSearchName || !segment || !opportunitySegment"
      (click)="sendExperts('remain')"
    >
      <span>Send &amp; remain</span>
      @if (showSendAndRemainButtonLoader) {
        <app-spinner size="sm" />
      }
    </button>
    <button
      class="button button--primary"
      id="submitAndGo"
      data-test-id="select-opportunity-dialog-send-and-go"
      [style]="{ 'pointer-events': showSendAndRemainButtonLoader || showSendAndGoButtonLoader ? 'none' : 'initial' }"
      [disabled]="!client || !opportunity || !newSearchName || !segment || !opportunitySegment"
      (click)="sendExperts('go')"
    >
      <span>Send &amp; go</span>
      @if (showSendAndGoButtonLoader) {
        <app-spinner size="sm" />
      }
    </button>
  </div>
</div>
